import React, { Component } from 'react';

import moment from 'moment';
import parse from 'html-react-parser';

import apiUtil from '../../../../api/apiUtil.jsx';
import AuditTrailApi from '../../../../api/OLD/Dispatch/AuditTrail.jsx';

import CustomDialog from '../../../../components/OLD/Dialog/CustomDialog.jsx';
import AuditTrailListUser from './AuditTrailListUser.jsx';
 
import { 
    Badge,
} from "react-bootstrap-v5";


class AuditTrailDialogUser extends Component {
  
    constructor(props){
        super(props);

        let isOpen = ((props.isOpen === false) || (props.isOpen === true)) ? props.isOpen : false;
        let userEmail = (props.userEmail) ? props.userEmail : null;
        let title = (props.title && props.title !== '') ? props.title : '';

        this.state = {
            isLoading: false,
            items: null,

            isOpen: isOpen,
            userEmail: userEmail,
            title: title,
            totalRows: 0,
            pageSize: 30,
            currentPage: 1,
            searchQuery: '',
            objectType: '',
        }
    }

    componentWillReceiveProps(nextProps) {
		if (nextProps.isOpen !== this.state.isOpen) {
            let isOpen = ((nextProps.isOpen === false) || (nextProps.isOpen === true)) ? nextProps.isOpen : false;
			this.setState({
				isOpen: isOpen,
                totalRows: 0,
                currentPage: 1,
			}, () => {
                if(this.state.isOpen){
                    this.callAuditTrailApi();
                }
            });
        }

        if (nextProps.userEmail !== this.state.userEmail) {
            let userEmail = (nextProps.userEmail) ? nextProps.userEmail : null;
			this.setState({
				userEmail: userEmail,
                totalRows: 0,
                currentPage: 1,
			});
        }
	}


    /* API */
    callAuditTrailApi = () => {
        let token = '';

        this.setState({
            isLoading: true,
        });

        let data = {
          currentPage: this.state.currentPage,
          pageSize: this.state.pageSize,
          searchQuery: this.state.searchQuery,
          objectType: this.state.objectType,
          sortColumn: 'created',
          sortDir: 'desc',
          userEmail: this.state.userEmail,
        };
    
        AuditTrailApi.getAuditTrailUser(
          data, 
          token
        ).then(result => {
          apiUtil.parseResult(result, (data) => {
            let total = 0;
            let items = [];
            if(data && data.data && data.data.length > 0){
                total = data.total;

                let dataItems = data.data.sort((a, b) => new Date(b.updated) - new Date(a.updated));
                items = dataItems.map((item, i) => {
                    return {
                        id: item.auditTrailId,
                        objectType: item.objectType,
                        objectId: item.objectId,
                        item: item,
                        time: moment(item.updated).format('MMM. DD, YYYY hh:mm A'),
                        color: 'primary',
                        contentTitle: <Badge bg={'primary'}>{apiUtil.getAuditTrailLabel(item.objectType)}</Badge>,
                        contentDesc: <div>{parse(item.description)}</div>,
                        isLoadingDetails: false,
                        showDetails: false,
                        details: null,
                    }
                });
            }

            this.setState({
                isLoading: false,
				items: items,
                totalRows: total,
			});
          }, (error, type) => {
            this.setState({
                isLoading: false,
				items: null,
                totalRows: 0,
			});
          });
        });
    }
    /* END API */


    render() {
        return <CustomDialog
            open={this.state.isOpen}
            fullWidth={true}
            onClose={() => {
                this.setState({
                    isOpen: false,
                    items: null,
                }, () => {
                    if(this.props.onClose){
                        this.props.onClose();
                    }
                });
            }}
        >
            <AuditTrailListUser
                items={this.state.items}
                userEmail={this.state.userEmail}
                title={this.state.title}
                totalRows={this.state.totalRows}
                pageSize={this.state.pageSize}
                currentPage={this.state.currentPage}
                isLoading={this.state.isLoading}
                details={this.props.details}
                manageData={this.props.manageData}
                showFilter={this.props.showFilter}
                onChangePage={(page) => {
                    if(this.state.currentPage !== page){
                        this.setState({
                            currentPage: page,
                        }, () => {
                            this.callAuditTrailApi();
                        });
                    }
                }}
                onChangeFilters={(searchQuery, objectType) => {
                    this.setState({
                        currentPage: 1,
                        searchQuery: searchQuery,
                        objectType: objectType,
                    }, () => {
                        this.callAuditTrailApi();
                    });
                }}
                onClose={() => {
                    this.setState({
                        isOpen: false,
                        items: null,
                    }, () => {
                        if(this.props.onClose){
                            this.props.onClose();
                        }
                    });
                }}
            />
        </CustomDialog>
    }
}

export default AuditTrailDialogUser;
